import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { TipoCuenta } from "app/main/apps/shared/interfaces/tipo-cuenta.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-pago",
    templateUrl: "./pago.component.html",
    styleUrls: ["./pago.component.scss"],
})
export class PagoComponent implements OnInit {
    @Input() contratista: ContratistaDTO;
    @Input() eliminado: boolean;
    @Output() openDialogActualizaPago: EventEmitter<any> = new EventEmitter();
    constructor(public _menuUsuarioSrvc: MenuUsuarioService) {}

    ngOnInit(): void {}

    dialogActualizar() {
        this.openDialogActualizaPago.emit(this.contratista);
    }
}
